export default {
  auth: {
    tokenRefresh: 'tokenRefresh',
    signIn: 'signin',
    signUp: 'signup',
    passwordReset: 'passwordReset',
    passwordResetConfirm: 'passwordResetConfirm',
  },
  shelf: {
    pdf: 'shelf/file/{{fileOguid}}/type/ORIGINAL.PDF',
    preview: 'shelf/file/{{fileOguid}}/page/{{page}}',
    upload: 'shelf',
  },
  users: {
    current: 'user',
    generateAPIKey: 'generateAPIKey',
    organisationSignatures: 'userOrganisationSignatures',
    settings: 'user/settings',
  },
  userFilters: {
    list: 'userFilters',
    single: 'userFilters/{{ filterOguid }}',
  },
  envelopes: {
    list: 'envelopes',
    actionRequiredCounts: 'envelopes/actionRequiredCounts',
    envelope: 'boxes/{{ boxOguid }}/envelopes/{{ envelopeOguid }}',
    generateSignLink: 'envelopes/generateSignLink',
    generateShare: 'envelopes/{{ envelopeOguid }}/generateShare',
    flowStop: 'envelopes/{{ envelopeOguid }}/flowStop',
    file: 'envelopes/{{ envelopeOguid }}/files/{{ fileIndex }}/type/{{ fileType }}',
    commentFile: 'envelopes/{{ envelopeOguid }}/commentFiles/{{ commentFileOguid }}',
    todos: 'envelopes/{{ envelopeOguid }}/todos',
    signing: {
      doHash: 'envelopes/{{ envelopeOguid }}/files/{{ fileIndex }}/doHash',
      doSign: 'envelopes/{{ envelopeOguid }}/files/doSign',
    },
    exportExcelJobs: 'envelopes/exportExcelJobs',
    exportExcelJob: 'envelopes/exportExcelJobs/{{ exportExcelJobOguid }}',
    exportExcelJobFile: 'envelopes/exportExcelJobs/{{ exportExcelJobOguid }}/file',
    exportZipJobs: 'envelopes/exportZipJobs',
    exportZipJob: 'envelopes/exportZipJobs/{{ exportZipJobOguid }}',
    exportZipJobFile: 'envelopes/exportZipJobs/{{ exportZipJobOguid }}/file'
  },
  mandates: {
    list: '/users/mandates',
    listBox: '/boxes/{{ boxOguid }}/mandates',
    create: '/mandates',
    single: '/mandates/{{ oguid }}',
  },
  metadata: {
    currencies: 'currencies',
    timeZones: 'timeZones',
  },
  verify: {
    confirm: 'verify/phoneCheckConfirm',
    init: 'verify/phoneCheckInit',
  },
  shared: {
    getDocumentFile:
      '/shared/{{ sharedLinkOguid }}/envelope/file/{{ fileIndex }}/type/{{ fileType }}',
    getDocumentReview:
      '/shared/{{ sharedLinkOguid }}/envelope/file/{{ fileIndex }}/page/{{ page }}',
    generateShare: '/envelopes/{{ envelopeOguid }}/generateShare',
    completeTask: '/shared/{{ sharedLinkOguid }}/completeTask',
  },
  boxes: {
    webHookIntegration: '/boxes/{{ boxOguid }}/webHookIntegration',
    boxes: '/boxes',
    changeBox: '/boxes/{{ boxOguid }}',
    getLogo: '/logo/boxes/{{ boxOguid }}',
    changeLogo: '/boxes/{{ boxOguid }}/logo',
    users: {
      list: '/boxes/{{ boxOguid }}/users',
      change: '/boxes/{{ boxOguid }}/users/{{ userBoxOguid }}',
    },
    members: '/boxes/{{ boxOguid }}/members',
    invites: {
      list: '/boxes/{{ boxOguid }}/invites',
      create: '/boxes/{{ boxOguid }}/userInvite',
      repeat: '/boxes/{{ boxOguid }}/invitesRepeat',
      change: '/boxes/{{ boxOguid }}/invites/{{ inviteOguid }}',
    },
    envelopeFields: {
      list: '/boxes/{{ boxOguid }}/envelopeFields',
      reorder: '/boxes/{{ boxOguid }}/envelopeFields/reorder',
      single: '/boxes/{{ boxOguid }}/envelopeFields/{{ fieldKey }}',
      values: '/boxes/{{ boxOguid }}/envelopeFields/{{ fieldKey }}/values',
    },
    labelGroups: {
      list: '/boxes/{{ boxOguid }}/labelGroups',
      reorder: '/boxes/{{ boxOguid }}/labelGroups/reorder',
      single: '/boxes/{{ boxOguid }}/labelGroups/{{ groupKey }}',
    },
    labels: {
      list: '/boxes/{{ boxOguid }}/labels',
      reorder: '/boxes/{{ boxOguid }}/labels/reorder',
      single: '/boxes/{{ boxOguid }}/labels/{{ labelFullKey }}',
      assign: '/boxes/{{ boxOguid }}/envelopes/labels/{{ labelFullKey }}',
      remove: '/boxes/{{ boxOguid }}/envelopes/labels/{{ labelFullKey }}/delete',
    },
    subdivisions: {
      list: '/boxes/{{ boxOguid }}/subdivisions',
      single: '/boxes/{{ boxOguid }}/subdivisions/{{ subdivisionOguid }}',
    },
    contactDirectory: {
      list: '/boxes/{{ boxOguid }}/contactDirectory',
      load: '/boxes/{{ boxOguid }}/contactDirectory/load',
      single: '/boxes/{{ boxOguid }}/contactDirectory/{{ contactOguid }}',
    },
    envelopeTemplates: {
      list: '/boxes/{{ boxOguid }}/envelopeTemplates',
      reorder: '/boxes/{{ boxOguid }}/envelopeTemplates/reorder',
      single: '/boxes/{{ boxOguid }}/envelopeTemplates/{{ envelopeTemplateOguid }}',
      resolveMarks: '/boxes/{{ boxOguid }}/envelopeTemplates/prepositionedMarks/resolve',
      file: '/boxes/{{ boxOguid }}/envelopeTemplates/{{ envelopeTemplateOguid }}/files/{{ fileOguid }}/type/{{ fileType }}',
      filePage: '/boxes/{{ boxOguid }}/envelopeTemplates/{{ envelopeTemplateOguid }}/files/{{ fileOguid }}/page/{{ page }}',
      generateDocuments: '/boxes/{{ boxOguid }}/envelopeTemplates/{{ envelopeTemplateOguid }}/generateDocuments',
      previewWorkflow: '/boxes/{{ boxOguid }}/envelopeTemplates/{{ envelopeTemplateOguid }}/previewWorkflow',
      preProcessingJobs: '/boxes/{{ boxOguid }}/envelopeTemplates/{{ envelopeTemplateOguid }}/preProcessingJobs',
      preProcessingJob: '/boxes/{{ boxOguid }}/envelopeTemplates/{{ envelopeTemplateOguid }}/preProcessingJobs/{{ preProcessingJobOguid }}',
    },
  },
  tasks: {
    markIsRead: '/tasks/markIsRead',
    complete: '/tasks/{{ taskOguid }}/complete',
    decline: '/tasks/{{ taskOguid }}/decline',
    graphicalSigning: '/tasks/{{ taskOguid }}/graphicalSigning',
    cloudDigitalSigning: '/tasks/{{ taskOguid }}/cloudDigitalSigning',
    selfie: '/tasks/{{ taskOguid }}/selfie',
  }
};
